import { axios, Response } from '../index'

const unbindResponsible = (
  patientId: string,
  responsibleId: string
): Response<null> => {
  return axios.delete(`/v1/patients/${patientId}/responsible/${responsibleId}`)
}

export default unbindResponsible
